import Cookies from 'js-cookie';

import { AUTH_COOKIES } from '@libs/core';

export const recaptchaString = {
    checkboxFail: 'Recaptcha failed, try again',
    checkboxRender: 'Please prove you are human',
    checkboxAction: 'Please complete the recaptcha',
};

export function isTestRun() {
    return !!window.automatedTestRun;
}

export async function setRecaptchaValues(recaptchaToken: string, isCheckbox?: boolean) {
    if (!isTestRun()) {
        Cookies.set(isCheckbox ? AUTH_COOKIES.RECAPTCHA_TOKEN_CHECKBOX : AUTH_COOKIES.RECAPTCHA_TOKEN, recaptchaToken);

        if (isCheckbox) {
            Cookies.set(AUTH_COOKIES.RECAPTCHA_IS_CHECKBOX, 'true');
        }
    }
}

export function isCheckboxRendered(checkboxDivId?: string) {
    return checkboxDivId ? !!document.querySelector(`#${checkboxDivId}`)?.querySelector('iframe') : undefined;
}

export async function resetRecaptchaValues(checkboxId?: number) {
    Cookies.remove(AUTH_COOKIES.RECAPTCHA_TOKEN);
    Cookies.remove(AUTH_COOKIES.RECAPTCHA_IS_CHECKBOX);

    if (typeof checkboxId === 'number') {
        window.grecaptcha?.enterprise.reset(checkboxId);
    }
}
